import clsx from 'clsx';
import React from 'react';
import { responsiveCssProperties } from '../../utils';
import { Box } from '../Box';
import { getInitials } from './AvatarUtils';
import { useAvatarContext } from './AvatarContext';
import './Avatar.css';
export const Avatar = React.forwardRef(function Avatar(props, ref) {
    const { children, className, name = '', src, variant = 'user', size, color, backgroundColor = variant === 'action' ? 'secondary' : undefined, ...rest } = props;
    const avatarContext = useAvatarContext();
    const initials = getInitials(name, size);
    let content = children;
    if (!content) {
        content = src ? React.createElement("img", { src: src, alt: "" }) : initials;
    }
    return (React.createElement(Box.Restricted, { ...rest, elementType: "span", className: clsx('mollie-ui-avatar', {
            'mollie-ui-avatar--with-text': typeof content === 'string',
            [`mollie-ui-avatar--${variant}`]: variant,
            [`mollie-ui-avatar--${size}`]: size,
            'mollie-ui-avatar--truncate-indicator': avatarContext.isTruncated,
        }, className), style: {
            ...responsiveCssProperties('--mollie-ui-avatar-background-color', backgroundColor, {
                primary: 'var(--mollie-ui-color-components-avatar-action-background-primary)',
                secondary: 'var(--mollie-ui-color-components-avatar-action-background-secondary)',
                tertiary: 'var(--mollie-ui-color-components-avatar-action-background-tertiary)',
                negative: 'var(--mollie-ui-color-components-avatar-action-background-negative)',
                positive: 'var(--mollie-ui-color-components-avatar-action-background-positive)',
                blue: 'var(--mollie-ui-color-components-avatar-organisation-background-blue)',
                green: 'var(--mollie-ui-color-components-avatar-organisation-background-green)',
                red: 'var(--mollie-ui-color-components-avatar-organisation-background-red)',
                yellow: 'var(--mollie-ui-color-components-avatar-organisation-background-yellow)',
                purple: 'var(--mollie-ui-color-components-avatar-organisation-background-purple)',
            }),
            ...responsiveCssProperties('--mollie-ui-avatar-foreground-color', backgroundColor, {
                [backgroundColor || '']: 'var(--mollie-ui-color-components-avatar-action-foreground-primary)',
                primary: 'var(--mollie-ui-color-components-avatar-action-foreground-primary)',
                secondary: 'var(--mollie-ui-color-components-avatar-action-foreground-secondary)',
                tertiary: 'var(--mollie-ui-color-components-avatar-action-foreground-tertiary)',
            }),
            ...responsiveCssProperties('--mollie-ui-avatar-foreground-color', color),
        }, role: "img", "aria-label": name, ref: ref }, typeof content === 'string' ? (React.createElement("span", { className: "mollie-ui-avatar-letter" }, content)) : (content)));
});
//# sourceMappingURL=Avatar.js.map